import { apiRequest } from "./service";
import { LOGIN, SIGNUP, FORGOT_PASSWORD, GET_PATIENT_PROFILE, UPDATE_PATIENT_PROFILE, LOGOUT, DOCTOR_LOGIN, UPDATE_PASSWORD, VERIFY_TOKEN, DOCTOR_LOGOUT, ORGANIZATION_LOGIN, ORGANIZATION_LOGOUT, SUBADMIN_LOGOUT, SUBADMIN_LOGIN, UPDATE_PROFILE_BY_ORGANIZATION, ORGANIZATION_SIGNUP, UPDATE_PROFILE_BY_SUBADMIN, VERIFY_LOGIN_OTP, RESEND_LOGIN_OTP, RESEND_DOCTOR_LOGIN_OTP, VERIFY_DOCTOR_LOGIN_OTP, VERIFY_ORGANIZATION_LOGIN_OTP, RESEND_ORGANIZATION_LOGIN_OTP, VERIFY_SUBADMIN_LOGIN_OTP, RESEND_SUBADMIN_LOGIN_OTP, VALIDATE_ORGANIZATION_SIGNUP_STEP, REFRESH_TOKEN, PREORDER_ACTIVATION_SESSION, PREORDER_VERIFY_OTP, PREORDER_RESEND_OTP } from "./apiUrl";
let user = localStorage.getItem("userType")
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const v1 = "api/v1/";

const AUTH_URLS = {
  patient: {
    login: LOGIN,
    verifyOtp: VERIFY_LOGIN_OTP,
    resendOtp: RESEND_LOGIN_OTP
  },
  doctor: {
    login: DOCTOR_LOGIN,
    verifyOtp: VERIFY_DOCTOR_LOGIN_OTP,
    resendOtp: RESEND_DOCTOR_LOGIN_OTP
  },
  organization: {
    login: ORGANIZATION_LOGIN,
    verifyOtp: VERIFY_ORGANIZATION_LOGIN_OTP,
    resendOtp: RESEND_ORGANIZATION_LOGIN_OTP
  },
  subadmin: {
    login: SUBADMIN_LOGIN,
    verifyOtp: VERIFY_SUBADMIN_LOGIN_OTP,
    resendOtp: RESEND_SUBADMIN_LOGIN_OTP
  }
};

export const forgotPasswordAPI = (payload) => {
  const userType = sessionStorage.getItem("userType") || "patient";
  const apiUserType = userType === "subadmin" ? "sub-admin" : userType;
  const dynamicForgotPasswordUrl = `${apiUrl}api/v1/${apiUserType}/forgotpassword`;

  return apiRequest({
    apiUrl: dynamicForgotPasswordUrl,
    method: "POST",
    payload,
    undefined,
    isPublic: true
  });
}

export const updatePasswordAPI = (payload) => {
  const { token, password } = payload;

  // Determine user type from current URL path
  const currentPath = window.location.pathname;
  let userType = "patient"; // default

  if (currentPath.includes('/doctor/')) {
    userType = "doctor";
  } else if (currentPath.includes('/organization/')) {
    userType = "organization";
  } else if (currentPath.includes('/subadmin/')) {
    userType = "sub-admin";
  }

  const dynamicUpdatePasswordUrl = `${apiUrl}${v1}${userType}/update-password?token=${token}`;

  return apiRequest({
    apiUrl: dynamicUpdatePasswordUrl,
    method: "PUT",
    payload: password,
    undefined,
    isPublic: true
  });
}

export const verifyTokenAPI = (payload) => {
  // Determine user type from current URL path
  const currentPath = window.location.pathname;
  let userType = "patient"; // default

  if (currentPath.includes('/doctor/')) {
    userType = "doctor";
  } else if (currentPath.includes('/organization/')) {
    userType = "organization";
  } else if (currentPath.includes('/subuser/')) {
    userType = "sub-admin";
  }

  const dynamicVerifyTokenUrl = `${apiUrl}${v1}${userType}/verify-password-reset-token?token=${payload}`;

  return apiRequest({
    apiUrl: dynamicVerifyTokenUrl,
    method: "GET",
    undefined,
    undefined,
    isPublic: true
  });
}



// ==========================================
// UNIFIED LOGIN API
// ==========================================
export const loginApi = (payload, userType = null) => {

  const type = userType || sessionStorage.getItem("userType") || "patient";
  const urlOrFn = AUTH_URLS[type]?.login;

  if (!urlOrFn) {
    throw new Error(`Invalid user type: ${type}`);
  }

  const apiUrl = typeof urlOrFn === 'function' ? urlOrFn() : urlOrFn;

  return apiRequest({
    apiUrl,
    method: "POST",
    payload,
    isPublic: true
  });
};

// ==========================================
// UNIFIED VERIFY OTP API
// ==========================================
export const verifyLoginOtpApi = (payload, userType = null) => {
  const type = userType || sessionStorage.getItem("userType") || "patient";
  const urlOrFn = AUTH_URLS[type]?.verifyOtp;

  if (!urlOrFn) {
    throw new Error(`Invalid user type: ${type}`);
  }

  const apiUrl = typeof urlOrFn === 'function' ? urlOrFn() : urlOrFn;

  return apiRequest({
    apiUrl,
    method: "POST",
    payload,
    isPublic: true
  });
};

// ==========================================
// UNIFIED RESEND OTP API
// ==========================================
export const resendLoginOtpApi = (payload, userType = null) => {
  const type = userType || sessionStorage.getItem("userType") || "patient";
  const urlOrFn = AUTH_URLS[type]?.resendOtp;

  if (!urlOrFn) {
    throw new Error(`Invalid user type: ${type}`);
  }

  const apiUrl = typeof urlOrFn === 'function' ? urlOrFn() : urlOrFn;

  return apiRequest({
    apiUrl,
    method: "POST",
    payload,
    isPublic: true
  });
};

export const refreshTokenApi = (data) => {
  return apiRequest({
    apiUrl: REFRESH_TOKEN(),
    method: "POST",
    payload: data,
    isPublic: true
  });
};


export const doctorloginApi = (payload) =>
  apiRequest({
    apiUrl: DOCTOR_LOGIN,
    method: "POST",
    payload,
    undefined,
    isPublic: true
  });

export const organizationloginApi = (payload) =>
  apiRequest({
    apiUrl: ORGANIZATION_LOGIN,
    method: "POST",
    payload,
    undefined,
    isPublic: true
  });

export const signupApi = (payload) =>
  apiRequest({
    apiUrl: SIGNUP(),
    method: "POST",
    payload,
    undefined,
    isPublic: true
  });

export const getProfile = (payload) =>
  apiRequest({
    apiUrl: GET_PATIENT_PROFILE(),
    method: "GET",
    token: payload.token,
  });

export const updateProfile = (payload, token) => {

  console.log("user", payload)
  const url = user === "patient" ? UPDATE_PATIENT_PROFILE() : UPDATE_PROFILE_BY_SUBADMIN
  return apiRequest({
    apiUrl: url,
    method: "PUT",
    payload,
    token
  });
}
export const updateProfileSubadmin = (payload, token) => {

  console.log("user", payload)
  const url = user === "patient" ? UPDATE_PATIENT_PROFILE() : UPDATE_PROFILE_BY_SUBADMIN
  return apiRequest({
    apiUrl: url,
    method: "PUT",
    payload: payload.data,
    token: payload.token
  });
}


export const logout = (token,refreshToken) => {
  return apiRequest({
    apiUrl: LOGOUT(),
    method: "POST",
    token,
    payload: { refreshToken }
  })
}

export const doctorlogout = (token,refreshToken) => {
  return apiRequest({
    apiUrl: `${DOCTOR_LOGOUT}`,
    method: "POST",
    token,
    payload: { refreshToken }
  })
}
export const organizationlogout = (token,refreshToken) => {
  return apiRequest({
    apiUrl: `${ORGANIZATION_LOGOUT}`,
    method: "POST",
    token,
    payload: { refreshToken }
  })
}
export const organizationResetprofile = (payload, token) => {
  return apiRequest({
    apiUrl: UPDATE_PROFILE_BY_ORGANIZATION,
    method: "PUT",
    payload,
    token
  });
}
export const subadminResetprofile = (payload, token) => {
  return apiRequest({
    apiUrl: UPDATE_PROFILE_BY_SUBADMIN,
    method: "PUT",
    payload,
    token
  });
}
export const subadminlogout = (token, refreshToken) => {
  return apiRequest({
    apiUrl: `${SUBADMIN_LOGOUT}`,
    method: "POST",
    token,
    payload: { refreshToken }  
  })
}
export const subadminloginApi = (payload) =>
  apiRequest({
    apiUrl: SUBADMIN_LOGIN,
    method: "POST",
    payload,
    undefined,
    isPublic: true
  });
export const organizationsignupApi = (payload) => {
  return apiRequest({
    apiUrl: ORGANIZATION_SIGNUP,
    method: "POST",
    payload,
    undefined,
    isPublic: true
  })
}

export const validateOrganizationSignupStep = (payload) =>
  apiRequest({
    apiUrl: VALIDATE_ORGANIZATION_SIGNUP_STEP,
    method: "POST",
    payload,
    undefined,
    isPublic: true
  });

// Exchanges the one-time code minted when a patient activates their account
// from a pre-order, so they are signed in without retyping the password they
// just chose. Public: there is no session to authenticate with yet.
export const activationSessionApi = (payload) =>
  apiRequest({
    apiUrl: PREORDER_ACTIVATION_SESSION,
    method: "POST",
    payload,
    isPublic: true,
  });

// Confirms a pre-order signup with the six-digit code that was emailed, and
// returns a session so the patient carries on in the same tab.
export const verifyPreorderOtpApi = (payload) =>
  apiRequest({ apiUrl: PREORDER_VERIFY_OTP, method: "POST", payload, isPublic: true });

export const resendPreorderOtpApi = (payload) =>
  apiRequest({ apiUrl: PREORDER_RESEND_OTP, method: "POST", payload, isPublic: true });
